var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6437 6.35112C17.1938 4.901 15.2039 4.00084 12.9939 4.00065C8.57391 4.00029 5.00361 7.58 5.00325 12C5.00289 16.42 8.57259 20.0003 12.9926 20.0007C16.7226 20.001 19.8328 17.4512 20.7231 14.0013L18.6431 14.0011C17.8229 16.3311 15.6028 18.0009 12.9928 18.0007C9.68276 18.0004 6.99298 15.3102 6.99325 12.0002C6.99352 8.69016 9.68374 6.00038 12.9937 6.00065C14.6537 6.00079 16.1337 6.69091 17.2136 7.781L13.9933 11.0007L20.9933 11.0013L20.9939 4.00131L18.6437 6.35112Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh24Px);
export default __webpack_public_path__ + "static/media/refresh_24px.65ecc3d923e1d7fe3af7858d300f256e.svg";
export { ForwardRef as ReactComponent };